import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNodeRedComponent } from './simple-icons-node-red.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNodeRedComponent ],
    exports:      [ SimpleIconsNodeRedComponent ],
    bootstrap:    []
})
export class SimpleIconsNodeRedModule {}
